import axios from 'axios'

export default {

  // Signed file URLs expire, so fetch one when the user clicks download.
  freshUrl(downloadId) {
    return axios({
      url: 'downloads/' + downloadId + '/url'
    })
  }
}
